import { EnhancedLink } from '@ui/enhanced-components/enhanced-components'
import clsx from 'clsx'
import React, { Fragment, type PropsWithChildren } from 'react'

type CardProps = {
  isClickable?: boolean
  ref?: any
  href?: string
  className?: string
}

export const Card: React.FC<PropsWithChildren<CardProps>> = ({
  isClickable = false,
  className = '',
  ref,
  children,
  href,
}) => {
  const clickableProps = isClickable
    ? {
        href,
        className: 'w-full cursor-pointer hover:no-underline',
        ref: ref,
      }
    : {}
  const LinkComponent = isClickable ? EnhancedLink : Fragment

  return (
    <LinkComponent {...clickableProps}>
      <div
        className={clsx(
          'flex h-full w-full flex-col rounded-md border border-solid border-theme-default-accent2 bg-background-default text-text-default shadow-[0_5px_10px_0_rgb(35,35,35,0.06)]',
          className
        )}
      >
        {children}
      </div>
    </LinkComponent>
  )
}
